import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Cog from './icon-cog.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Cog {...validProps} />;
}
SvgComponent.iconName = 'cog';

export const CogIcon = svgIconWrapper(SvgComponent);
